<app-header></app-header>

<main class="app-main">
    <router-outlet></router-outlet>
</main>